import React from "react";
import { RiRefreshLine } from "react-icons/ri";

const Component = () => {
    return (
        <div className="container mx-auto px-10 py-10 lg:px-0">
            <div className="flex flex-row items-center justify-center space-x-5 uppercase text-gray-500">
                <RiRefreshLine className="h-10 w-10 animate-spin" />
                <span className="text-base font-semibold lg:text-lg">
                    Cargando el contenido...
                </span>
            </div>
        </div>
    );
};

export default Component;
